import * as action from './bookingcalendarAction'
import { default as actionType } from './bookingcarlendarType'
import { default as reducer } from './bookingcarlendarReducer'

export const BOOKINGCALENDAR = {
  action,
  actionType,
  reducer
}
